import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api, { formatApiError } from "../../lib/api";

export default function AdminComments() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/admin/comments").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };

  useEffect(load, []); // eslint-disable-line

  const remove = async (item) => {
    if (!window.confirm("Excluir este comentário?")) return;
    try {
      await api.delete(`/comments/${item.id}`);
      toast.success("Comentário excluído.");
      setItems(items.filter((c) => c.id !== item.id));
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  if (loading) return <p className="font-serif text-zinc-500">Carregando…</p>;

  if (items.length === 0)
    return <p className="text-sm text-zinc-500" data-testid="admin-comments-empty">Nenhum comentário no mural ainda.</p>;

  return (
    <div className="flex flex-col gap-px bg-gold/10" data-testid="admin-comments-list">
      {items.map((item) => (
        <div key={item.id} className="bg-[#0a0a0a] px-6 py-5" data-testid={`admin-comment-${item.id}`}>
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <p className="text-sm text-zinc-100">
                <span className="font-semibold">{item.user_name}</span>
                <span className="text-zinc-500"> em </span>
                <span className="text-gold/80">{item.mentoria_title || "Conteúdo"}</span>
              </p>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400">{item.text}</p>
              <p className="mt-2 text-[0.65rem] uppercase tracking-[0.15em] text-zinc-600">
                {item.created_at ? new Date(item.created_at).toLocaleDateString("pt-BR") : ""}
                {(item.reactions || []).length > 0 && ` · ${item.reactions.length} reações ✦`}
              </p>
            </div>
            <button onClick={() => remove(item)} className="shrink-0 border border-red-900/50 p-2.5 text-red-400 transition-colors hover:border-red-500" data-testid={`admin-comment-delete-${item.id}`} aria-label="Excluir comentário">
              <Trash2 size={14} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
